var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"width":_vm.width,"height":_vm.height,"fill":"black","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z","fill":"#000000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }